export default "__VITE_ASSET__BvFFsTDg__"